import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { JobPositionService } from '../../services/job-position.service';

import * as jobPositionsActions from '../actions/job-positions.actions';

@Injectable()
export class JobPositionsEffetcs {
  constructor(private actions$: Actions, private jobPositionsService: JobPositionService) {}

  getJobPositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(jobPositionsActions.uploadJobPositions),
      mergeMap(() =>
        this.jobPositionsService.listJobPositions().pipe(
          map((jobPositions) => jobPositionsActions.listJobPositionsSuccess({ jobPositions })),
          catchError((err) => of(jobPositionsActions.listJobPositionsError({ payload: err }))),
        ),
      ),
    ),
  );
}
//TODO: comentar
